import "./pages/behandelingen"
import "./pages/reviews"
import "./pages/contact"
import "./pages/wooproduct"
